// extracted by mini-css-extract-plugin
module.exports = {"job-filter-input":"JobsPage_job-filter-input_2U5zv","jobs-table":"JobsPage_jobs-table_CwDa5"};